import {
  REQUEST_DATA,
  RECEIVE_DATA,
  RECEIVE_DATA_ERROR,
  DISPLAY_LOADING_WARNING,
  CATEGORY_TOGGLE,
  SELECTED_CATEGORIES_CHANGE,
  RESET_DATA,
  PRINT_MODE,
} from 'Config/types';
import config from 'Config/appConfig';

export default function dataReducer(state = {}, { type = '', payload } = {}) {
  switch (type) {
    case PRINT_MODE:
      return { ...state, print: true };
    case REQUEST_DATA:
      return { ...state, isFetching: true, error: null };
    case RECEIVE_DATA:
      return {
        ...state,
        isFetching: false,
        data: payload,
      };
    case DISPLAY_LOADING_WARNING:
      return {
        ...state,
        loadingWarning: config.loadingWarning,
      };
    case RECEIVE_DATA_ERROR: {
      const { response: { status = 500 } = {} } = payload;
      console.error(payload);
      return {
        ...state,
        isFetching: false,
        data: [],
        response: payload.response,
        error: config.errorStatusStrings[status],
      };
    }
    case SELECTED_CATEGORIES_CHANGE: {
      return {
        ...state,
        selectedCategories: [...payload],
      };
    }
    case CATEGORY_TOGGLE: {
      const selected = state.selectedCategories || [];
      if (-1 < selected.indexOf(payload.category)) {
        selected.splice(selected.indexOf(payload.category), 1);
      } else {
        selected.push(payload.category);
      }
      return {
        ...state,
        selectedCategories: [...selected], // Do this so we aren't just mutating state
      };
    }
    case RESET_DATA:
      return {
        ...state,
        selectedCategories: [],
      };
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/data.js